import React, { useEffect, useState } from "react";
import Layout from "../components/layout/layout";
import PreParser from "../components/preParser";
import HTMLParser from "../components/htmlParser";
import PostTitle from "../components/blocks/core/post-title";
import Content from "../components/blocks/gco/content";
import Time from "../components/time";
import { Link } from "gatsby";
const performSearch = async (query, endpoint) => {
    const graphqlQuery = `query Search($search: String = "${query}") {
    pages(where: {search: $search}) {
      nodes {
        title
        uri
        seo {
          description
        }
      }
    }
    posts(where: {search: $search}) {
      nodes {
        date
        title
        uri
        seo {
          description
        }
        categories {
          nodes {
            name
          }
        }
      }
    }
  }`;
    const payload = {
        operationName: "Search",
        query: graphqlQuery,
        variables: null,
    };
    let results = await fetch(endpoint, {
        method: "POST",
        headers: {
            "Content-type": "application/json",
            Accept: "application/json",
        },
        body: JSON.stringify(payload),
    });
    results = await results.json();
    return results.data;
};
const SearchResults = ({ searchQuery, endpoint }) => {
    const [results, updateResults] = useState({});
    const [query, setQuery] = useState(null);
    const effect = () => {
        (async () => {
            updateResults({});
            setQuery(searchQuery);
            const results = await performSearch(searchQuery, endpoint);
            updateResults(results);
        })();
    };
    useEffect(effect, [searchQuery]);
    return (React.createElement("section", { className: "wp-block-group search" }, query?.length ? (React.createElement(React.Fragment, null,
        Object.keys(results).length === 0 ? (React.createElement("div", { className: "search-loader" },
            React.createElement("p", null, "Chargement en cours..."),
            React.createElement("span", null))) : (React.createElement("h2", null,
            results?.posts?.nodes?.length + results?.pages?.nodes?.length,
            " ",
            "r\u00E9sultat",
            results?.posts?.nodes?.length + results?.pages?.nodes?.length > 1
                ? "s"
                : "",
            " ",
            "de recherche pour \u00AB\u00A0",
            query,
            "\u00A0\u00BB")),
        results?.pages?.nodes?.length ? (React.createElement(React.Fragment, null,
            React.createElement("ul", { className: "is-style-list-no-disc" }, results.pages.nodes.map((page) => {
                return (React.createElement("li", { key: page.uri },
                    React.createElement(Link, { to: page.uri },
                        React.createElement(HTMLParser, null, `<p>Page</p><h3>${page.title}</h3><p>${page.seo.description}</p>`))));
            })))) : (React.createElement(React.Fragment, null)),
        results?.posts?.nodes?.length ? (React.createElement(React.Fragment, null,
            React.createElement("ul", { className: "is-style-list-no-disc" }, results.posts.nodes.map((page) => {
                return (React.createElement("li", { key: page.uri },
                    React.createElement(Link, { to: page.uri },
                        React.createElement("p", null, "Actualit\u00E9s"),
                        React.createElement(HTMLParser, null, `<h3>${page.title}</h3>`),
                        React.createElement("div", { className: "wp-block-columns" },
                            page.categories.nodes.map((cat, i) => {
                                return (React.createElement("p", { key: i },
                                    React.createElement(HTMLParser, null, cat.name)));
                            }),
                            React.createElement(Time, { date: page.date })),
                        React.createElement(HTMLParser, null, `<p>${page.seo.description}</p>`))));
            })))) : (React.createElement(React.Fragment, null)),
        results?.posts?.nodes?.length === 0 &&
            results?.pages?.nodes?.length === 0 ? (React.createElement("p", null, "Aucun r\u00E9sultat n'a \u00E9t\u00E9 obtenu pour votre recherche. Vous pouvez r\u00E9essayer en modifiant les termes recherch\u00E9s")) : (React.createElement(React.Fragment, null)))) : (React.createElement("p", null, "Utilisez le champ ci-dessus pour effectuer une recherche sur le site."))));
};
const SearchPage = (props) => {
    const query = props?.location?.state?.query;
    return (React.createElement(React.Fragment, null,
        React.createElement(Layout, { data: props.data, infos: {
                postType: "search",
                title: query?.length
                    ? "Résultats de recherche : " + query
                    : "Moteur de recherche",
            }, seo: {
                description: props.data.wpTemplate?.seo?.description || "",
            } },
            React.createElement(PreParser, { structure: props.data.wpTemplate?.jsonContent || "" },
                React.createElement(PostTitle, null, props.data.wpTemplate?.title +
                    (query?.length ? "&nbsp;: «&nbsp;" + query + "&nbsp;»" : "")),
                React.createElement(Content, null,
                    React.createElement(SearchResults, { searchQuery: query, endpoint: props.data.sitePlugin.pluginOptions.url }))))));
};
export default SearchPage;
